import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Layout } from "antd"; 
import Header1 from "./Header1";
import Sidebar from "./Sidebar";

const { Content, Sider } = Layout;

export default function Dashboard() {
  const [collapsed, setCollapsed] = useState(false);
  const siderWidth = 260;
  const headerHeight = 80;

  return (
    <Layout style={{ minHeight: "100vh", overflow: "hidden" }}>
      {/* 1. Fixed Header */}
      <div style={{ 
        position: "fixed", 
        top: 0, 
        left: 0,
        right: 0,
        zIndex: 1000, 
        width: "100%",
        height: headerHeight
      }}>
        <Header1 />
      </div>

      <Layout hasSider style={{ marginTop: headerHeight }}> 
        {/* 2. Fixed Sidebar */}
        <Sider
          width={siderWidth}
          collapsible
          collapsed={collapsed}
          onCollapse={setCollapsed}
          breakpoint="lg"
          collapsedWidth="80"
          style={{
            overflowY: 'auto',
            height: `calc(100vh - ${headerHeight}px)`,
            position: 'fixed',
            left: 0,
            top: headerHeight,
            background: '#fff',
            zIndex: 900,
            borderRight: '1px solid #f0f0f0'
          }}
          theme="light"
        >
          <Sidebar collapsed={collapsed} />
        </Sider>

        {/* 3. Scrollable Content Area */}
        <Layout
          style={{
            marginLeft: collapsed ? 80 : siderWidth,
            transition: 'margin-left 0.2s',
            minHeight: `calc(100vh - ${headerHeight}px)`,
            background: '#f0f2f5'
          }}
        >
          <Content style={{ 
            padding: 0, 
            overflow: 'auto',
            height: `calc(100vh - ${headerHeight}px)`
          }}>
            {/* The Outlet renders your Profile page here */}
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
}